import React from 'react';
import styled from 'styled-components';
import MediaBox from "./mediaBox";



const EiFrame = styled.iframe`
  height: 100%;
  @media (max-width: ${props => (props.theme.breaks.mobile)}px) {
    height:100%;
  }
`;

const StartImage = styled.div`
  height: 100%;
  background-image: url(${props => (props.img !== "" && props.img !== undefined?props.img + "start.png":'./img/layout/360.svg')});
  background-repeat: no-repeat;
  background-position: center;
  background-size:${props => (props.img !== "" && props.img !== undefined?'cover':'25%')};
  @media (max-width: ${props => (props.theme.breaks.mobile)}px) {
    height:100%;
  }
`;
const ThreeSixty = styled.div`
  height: 100%;
  background-image: url('./img/layout/360.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 25%;
  @media (max-width: ${props => (props.theme.breaks.mobile)}px) {
    height:100%;
  }
`;

export default class Panorama extends React.Component {

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(active) {
    this.props.handleClick(active);
  }

  render() {
    return (
      <div>
        <MediaBox>
          {this.props.activeFrame === this.props.index &&
            <EiFrame onLoad={this.fullScreen} src={this.props.item.views[0]} title={this.props.item.name} style={{
              width: '100%',
              display: 'block'
            }} frameBorder={0} allow="fullscreen" allowFullScreen />
          }
          {this.props.activeFrame !== this.props.index &&
            <StartImage img={this.props.item.views[0]}>
              <ThreeSixty onClick={() => this.handleClick(this.props.index)} />
            </StartImage>
          }
        </MediaBox>

      </div>
    )
  }
}
